import { render } from "./WishList.vue?vue&type=template&id=682467e3&scoped=true"
import script from "./WishList.vue?vue&type=script&lang=js"
export * from "./WishList.vue?vue&type=script&lang=js"

import "./WishList.vue?vue&type=style&index=0&id=682467e3&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682467e3"]])

export default __exports__